<template>
  <section id="kit">
    <div class="container">
      <header class="circleHeader">
        <div>
          <h2>Keep in Touch</h2>
        </div>
      </header>
      <div class="kit-lead" v-if="page" v-html="page.kit.content"></div>
      <div class="newsletter-subscribe">
        <div class="form" v-if="!success">
          <div class="field">
            <input @keyup.enter="submit" v-model="email" type="email" placeholder="Your Email Address">
          </div>
          <div class="notification is-danger" v-if="error">{{ error }}</div>
          <button @click="submit">
            <img src="./NewsletterButton.svg" width="43" height="43">
            <span>Send</span>
          </button>
        </div>
        <div v-else>
          <h5><strong>Success!</strong><br>We'll be in touch!</h5>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'keep-in-touch',
    props: ['page', 'colorScheme'],
    beforeMount () {
      if (sessionStorage.getItem('newsletterSubscribe')) {
        this.success = true
      }
    },
    data () {
      return {
        email: '',
        firstName: '',
        lastName: '',
        success: false,
        error: null,
        page: null
      }
    },
    mounted () {
      this.fetchPost()
    },
    methods: {
      fetchPost () {
        let vm = this
        // GET /posts => get_single_post() [theme-folder]/api/functions.php
        vm.$axios.get('/posts', {
          params: {
            slug: 'participate'
          }
        })
          .then((response) => {
            vm.page = response.data
          })
          .catch((err) => {
            console.log(err)
          })
      },
      submit () {
        let vm = this
        // POST /subscribe => newsletter_subscribe() [theme-folder]/api/functions.php
        vm.$axios.post('/subscribe', {
          email: vm.email,
          first_name: vm.firstName,
          last_name: vm.lastName,
          tag: 'new-hillary'
        })
          .then((response) => {
            if (response.data.success) {
              vm.email = ''
              vm.lastName = ''
              vm.firstName = ''
              vm.success = true
              vm.error = null
              sessionStorage.setItem('newsletterSubscribe', true)
            } else {
              vm.error = response.data.data.message
            }
          })
      }
    },
    computed: {
      ...mapGetters([
        'siteInfo'
      ])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  $sectionColor: $turquoise

  section
    .circleHeader
      margin-bottom: 44px
    background: $sectionColor
    +until($tablet)
      padding: 30px
    +tablet
      padding-top: 5rem
      padding-bottom: 5rem
    .container
      h4
        +tablet
          font-size: 20px
        font-weight: bold
      h2
        +tablet
          width: 740px
          font-size: 36px
          line-height: 50px
        a
          color: inherit
          border-bottom: 2px solid
    .circleHeader
      margin-bottom: 0
      &:before
        background: $white
    .newsletter-subscribe
      margin-top: 15px
      .form
        position: relative
        max-width: 90%
        +smTablet
          max-width: 50%
        .is-grouped
          +until($tablet)
            display: block
            .control:first-child
              margin-right: 0
              margin-bottom: 0.75rem
        input
          width: 100%
          border: 0
          height: 48px
          padding: 15px 26px
          border-radius: 50px
          font-size: 1.1rem
          box-sizing: border-box
        button
          background: transparent
          margin-left: auto
          margin-right: 0
          display: block
          padding: 0
          +smTablet
            position: absolute
            bottom: -2px
            right: -60px
          span
            opacity: 0
            position: absolute
</style>



// WEBPACK FOOTER //
// KeepInTouch.vue?2de52ad0